/* eslint-disable object-shorthand, no-unused-vars, max-len */
import Swiper from 'swiper';
import {
    Navigation, Keyboard, A11y,
} from 'swiper/modules';

const siteLanguage = document.querySelector('html').getAttribute('lang');
const translations = {
    en: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        slideLabelMessage: '{{index}} of {{slidesLength}}',
    },
    fr: {
        prevSlideMessage: 'Diapositive précédente',
        nextSlideMessage: 'Diapositive suivante',
        paginationBulletMessage: 'Aller à la diapositive {{index}}',
        slideLabelMessage: '{{index}} sur {{slidesLength}}',
    },
};

// Use onreadystatechange because elements loaded async
document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
        // Resources
        const resourcesCarouselArray = document.querySelectorAll('.swiper-resources-js');
        resourcesCarouselArray.forEach((resourcesCarousel) => {
            if (resourcesCarousel.querySelector('.swiper')) {
                const featuredSlider = new Swiper(resourcesCarousel.querySelector('.swiper'), {
                    modules: [Navigation, Keyboard, A11y],
                    a11y: {
                        enabled: true,
                        prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
                        nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
                        paginationBulletMessage: `${translations[siteLanguage].paginationBulletMessage}`,
                        slideLabelMessage: `${translations[siteLanguage].slideLabelMessage}`,
                    },
                    slidesPerView: 1,
                    spaceBetween: 20,
                    speed: 500,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: resourcesCarousel.querySelector('.slider-button-next'),
                        prevEl: resourcesCarousel.querySelector('.slider-button-prev'),
                    },
                    roundLengths: true,
                    preventInteractionOnTransition: true,
                    watchSlidesProgress: true,
                    breakpoints: {
                        600: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                    },
                    on: {
                        slidePrevTransitionEnd() {
                            // Focus on the last fully visible slide
                            const fullyVisibleSlides = this.el.querySelectorAll('.swiper-slide-fully-visible');
                            const lastFullyVisibleSlide = fullyVisibleSlides[fullyVisibleSlides.length - 1];
                            if (lastFullyVisibleSlide) {
                                lastFullyVisibleSlide.setAttribute('tabindex', '-1');
                                lastFullyVisibleSlide.focus();
                            }
                        },
                        slideNextTransitionEnd() {
                            // Focus on the first fully visible slide
                            const fullyVisibleSlides = this.el.querySelectorAll('.swiper-slide-fully-visible');
                            const firstFullyVisibleSlide = fullyVisibleSlides[0];
                            if (firstFullyVisibleSlide) {
                                firstFullyVisibleSlide.setAttribute('tabindex', '-1');
                                firstFullyVisibleSlide.focus();
                            }
                        },
                    },
                });
            }
        });

        // Tags
        const tagsSwiperArray = document.querySelectorAll('.swiper-tags-js');
        tagsSwiperArray.forEach((tagsSwiper) => {
            if (tagsSwiper.querySelector('.swiper')) {
                const tagsSlider = new Swiper(tagsSwiper.querySelector('.swiper'), {
                    modules: [Navigation, Keyboard, A11y],
                    a11y: {
                        enabled: true,
                        prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
                        nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
                        paginationBulletMessage: `${translations[siteLanguage].paginationBulletMessage}`,
                        slideLabelMessage: `${translations[siteLanguage].slideLabelMessage}`,
                    },
                    slidesPerView: 1,
                    spaceBetween: 20,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: tagsSwiper.querySelector('.slider-button-next'),
                        prevEl: tagsSwiper.querySelector('.slider-button-prev'),
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                    },
                    watchOverflow: false,
                    watchSlidesProgress: true,
                    breakpoints: {
                        540: {
                            slidesPerView: 'auto',
                        },
                    },
                });
            }
        });
    }
};
